import { createSlice } from "@reduxjs/toolkit";

const initialStateValue = {
  email: "",
  pass: "",
  fname: "",
  sname: "",
  address: "",
  city: "",
  country: "",
  mobile: -1,
  serverid: -1,
  dateReg: "",
  activated: true,
  canceledCalls: -1,
  dateLastCall: "2023-02-08T14:10:42.613",
  userComment: "",
  user_type: -1,
  geoX: -1,
  geoY: -1,
  DateTimeFormat: "",
  DistanceUnits: "",
  Currency: "",
  CallCenterGetCost: false,
  countryCode: -1,
  ValidationState: -1,
  groupID: -1,
  promoCode: "",
  imageURL: "",
  google_key: "",
  calls_boundaries: {
    North: 0,
    West: 0,
    South: 0,
    East: 0,
  },
  allow_calls_for_select_drivers: false,
  allow_calls_for_favor_drivers: false,
  token: "",
};

export const AccountSlice = createSlice({
  name: "account",
  initialState: {
    value: initialStateValue,
  },
  reducers: {
    redux_login: (state, action) => {
      state.value = { ...state.value, ...action.payload };
    },
    redux_logout: (state) => {
      state.value = initialStateValue;
    },
  },
});
export const { redux_login, redux_logout } = AccountSlice.actions;

export default AccountSlice.reducer;
